import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MeetingTypeListViewComponent } from './meeting-type-list-view.component';
import { MeetingListModule } from '../meeting-list/meeting-list.module';
import { MeetingSchedulerSettingsModule } from '../schedule-settings/schedule-settings.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [MeetingTypeListViewComponent],
  imports: [MatTabsModule, CommonModule, MeetingSchedulerSettingsModule, MeetingListModule, TranslateModule],
  exports: [MeetingTypeListViewComponent],
})
export class MeetingTypeListViewModule {}
